var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'my-1': _vm.small }},[_c('v-tooltip',{attrs:{"top":"","content-class":"custom-top-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-chip',_vm._g(_vm._b({staticClass:"my-auto font-weight-600",class:{
          'd-inline mx-2': !_vm.visitList && _vm.small,
          'ml-4 mr-2': !_vm.visitList && !_vm.small,
        },attrs:{"color":_vm.priorityColor,"outlined":"","label":"","small":_vm.small}},'v-chip',attrs,false),on),[_vm._v(" "+_vm._s(_vm.priorityText)+" ")])]}}])},[_c('span',[_vm._v("Priority")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }